import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      this.showSuccess()
    }, () => {
      this.fallbackCopy()
    })
  }

  showSuccess() {
    const originalText = this.element.innerHTML
    this.element.innerHTML = `
      <svg class="-ml-1 mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
      </svg>
      Copied!
    `
    
    setTimeout(() => {
      this.element.innerHTML = originalText
    }, 2000)
  }

  fallbackCopy() {
    const textArea = document.createElement("textarea")
    textArea.value = this.textValue
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    
    try {
      document.execCommand('copy')
      this.showSuccess()
    } catch (err) {
      console.error('Fallback copy failed:', err)
    }
    
    document.body.removeChild(textArea)
  }
}